import React from "react";
import { Route, Routes } from "react-router-dom";
import Neat from "./neat/neat";
import ClickshareMain from "./clickshare/clickshareMain";
import NotFound from "pages/common/notFound";

/**
 * 파일명: Device.js
 * 작성자: 강연승
 * 작성일자: 25.02.06
 * 설명: 스마트 디바이스 라우터
 */
function Device() {
  return (
    <Routes>
      <Route path="neat/*" element={<Neat />} />
      <Route path="clickshare" element={<ClickshareMain />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Device;
